import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { styled } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';

import { Link } from '@confluence/route-manager';
import { SPACE_OVERVIEW } from '@confluence/named-routes';

import type { AccessDetailsDialogSpaceAccessDetailsQuery as AccessDetailsDialogSpaceAccessDetailsQuery$data } from './__types__/AccessDetailsDialogSpaceAccessDetailsQuery';

type SpaceDescriptionProps = {
	spaceInfo?: AccessDetailsDialogSpaceAccessDetailsQuery$data;
	isLoading: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpaceDescriptionContainer = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	alignItems: 'center',
	flexDirection: 'row',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpaceDescriptionLabel = styled.div({
	paddingLeft: token('space.100'),
	display: 'inline-block',
	color: token('color.text'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'a[data-testid="space-overview-link"]': {
		color: token('color.text'),
		textDecoration: 'underline',
	},
});

export const SpaceDescription: FC<SpaceDescriptionProps> = ({ spaceInfo, isLoading }) => {
	const space = spaceInfo?.space;
	const spaceKey = space?.key;
	const spaceUrl = spaceKey ? SPACE_OVERVIEW.toUrl({ spaceKey }) : '';
	const [iconPath, setIconPath] = useState<string | undefined>(space?.icon?.path);
	const isPersonalSpace = space?.type === 'personal';

	useEffect(() => {
		if (!isLoading && space?.icon?.path && space?.icon?.path !== iconPath) {
			setIconPath(space.icon.path);
		}
	}, [space?.icon?.path, isLoading, iconPath]);

	const avatarSrc =
		!isPersonalSpace && iconPath ? iconPath : require('../images/personal_space.png');

	return (
		<SpaceDescriptionContainer>
			<Avatar src={avatarSrc} size="xsmall" appearance="square" />
			<SpaceDescriptionLabel>
				<Link to={spaceUrl} target="_blank" testId="space-overview-link">
					{spaceInfo?.space?.name}
				</Link>
			</SpaceDescriptionLabel>
		</SpaceDescriptionContainer>
	);
};
